export default __webpack_public_path__ + "static/media/i-360video.58780cdc.svg";